<template>
  <div class="recharge">
     <div class="bg-w flex pd-20 a-center   ">
      <div class="pr-120">
        <div v-if="accInfo" class=" mt-10">
          <div class="flex a-center">
            <span class="f-c-blue fs-32 fs-b" style="">{{ $utils.Big(accInfo.balance||0).plus(accInfo.frozenAmount||0).toFixed(2) }}</span>
          </div>
          <div>运费余额（元）<a-icon class="pointer" type="question-circle" @click="showTips = true" /></div>
        </div>
      </div>
      <div class="v-line" />
      <div v-if="accInfo" class=" mt-10 pr-120">
        <div class="flex a-center">
          <span class=" fs-32 fs-b" style="">{{ $utils.Big(accInfo.balance||0).toFixed(2) }}</span>
          <span class="ml-10 f-c-blue pb-10">(冻结{{ $utils.Big(accInfo.frozenAmount||0).toFixed(2) }}元)</span>
        </div>
        <div>可用余额（元）</div>
      </div>
      <div class="v-line" />
      <div v-if="accInfo" class=" mt-10 pr-20">
        <div class="flex a-center">
          <span class=" fs-32 fs-b" style="">{{ $utils.Big(accInfo.yesterdayTotalFreight||0).toFixed(2) }}</span>
        </div>
        <div>昨日消费（元）</div>
      </div>
      <!-- <div class="">
        <div class="flex mt-10">
          <div class=""><span class="f-c-b3 fs-24">昨日消费：</span> <span class="f-c-blue fs-24" style="">{{ accInfo&&accInfo.yesterdayTotalFreight||0 }}元</span></div>
        </div>

      </div> -->
    </div>

    <div class="mt-20 bg-w  pd-20">
      <div class="flex a-center">
        <!-- <div class="fs-16  f-c-b">充值金额：</div> -->
        <div class="flex ">

          <div class="money-item mr-20" :class="money === 100?'c-active':''" @click="money=100">100元</div>
          <div class="money-item mr-20" :class="money === 300?'c-active':''" @click="money=300">300元</div>
          <div class="money-item mr-20" :class="money === 500?'c-active':''" @click="money=500">500元</div>
          <div class="money-item mr-20" :class="money === 1000?'c-active':''" @click="money=1000">1000元</div>
          <div class="money-item  " :class="money === 2000?'c-active':''" @click="money=2000">2000元</div>
        </div>
      </div>
      <div class="flex mt-20 a-center">
        <!-- <div class="fs-16  f-c-b"> 请选择在线支付方式：</div> -->
        <div @click="payType = 1" :class="payType === 1?'c-active':''" class="money-item mr-20 "> <img src="@/assets/pay/ali.png" class="w-32 mr-8" alt=""> 支付宝</div>
        <div @click="payType = 2" :class="payType === 2?'c-active':''" class="money-item mr-20 "> 对公转账（线下）</div>
      </div>
      
       <div v-if="payType == 2" class="bg-grey pd-20 mt-20">
        <div class="fs-20 fs-b ">企业支付宝</div>
        <div class="mt-10">
          公司名称:深圳市快金数据技术服务有限公司<br>
          支付宝账号:pay@kdniao.com
        </div>
        <div class="fs-20 fs-b mt-20">银行卡转账</div>
        <div class="mt-10">
          公司名称:深圳市快金数据技术服务有限公司<br>
          开户银行:上海浦东发展银行深圳分行营业部<br>
          银行账号:7917 0155 2000 14836
        </div>
        <div class="mt-10">
          *请在转账成功后保留您的转账截图并联系快递鸟客服人员，Tel：400-9633321，我们将在核实账款后为您开通服务。
        </div>
      </div>
      <div class="bg-grey pd-20 mt-20">
        充值说明：<br>
        1. 余额永久有效，您可以放心充值；<br>
        2. 预充值金额不支持退款；<br>
        3. 子账号无充值权限，由管理员账号充值后可给子账号使用。<br>
        <br>
        开发票请联系客服：<br>
        400-9633321
      </div>
      <div v-if="payType!=2">
      <div class="mt-30 fs-20 fs-b">应付款：<span style="color:rgba(207, 19, 34, 1);">￥{{ money }}</span></div>

      <div class="mt-10">
        <a-checkbox v-model="agree">我已阅读并同意 <span class="f-c-blue" @click="$userAgreement.display()">《快递鸟企业寄件用户协议》</span></a-checkbox>
      </div>
      <div class="mt-20 post-btn">
        <a-button type="primary" class="w-300" :loading="loading" @click.native="recharge">确定充值</a-button>
      </div>
      <div class="post-form" style="visiable:hidden"><div v-html="form" /></div>
      </div>
      <!-- <div v-else class="mt-20 post-btn" @click="showBack">
        <div class="post-form" v-html="form" />
        <a-button type="primary" class="w-300">确定充值</a-button>
      </div> -->
    </div>
    <!-- <a-modal v-model="visible" :title="null" :footer="null" >
            <div v-html="form"></div>
    </a-modal> -->

  </div>
</template>
<script>
export default {
  data() {
    return {
      payType: 1,
      accInfo: null,
      money: 0,
      agree: false,
      visible: false,
      form: '',
      loading: false

    }
  },
  watch: {
    async money(n) {

    }
  },
  async created() {
    const res = await this.$http(this.$api.accountGetAccount)
    this.accInfo = res
    this.money = 100
  },
  methods: {
    async getOrder() {
      try {
        this.loading = true
        const res = await this.$http(this.$api.rechargeDo, {
          paySource: 1,
          payAmount: this.money

        })
        this.form = res.submitForm

        setTimeout(() => {
          this.loading = false
          this.showBack()
          document.querySelector('.post-form form').submit()
        }, 200)
      } catch (error) {
        this.loading = false
      }
    },
    showBack() {
      this.$confirm({
        title: '是否交易成功',
        content: '支付完成前请不要关闭此窗口。完成支付后请根据您的情况点击以下按钮如需要人工协助请联系页面底部的客服电话。',
        okText: '已完成付款',
        okType: 'primary',
        cancelText: '遇到问题?',
        onOk: async() => {
          window.location.reload()
        },
        onCancel: () => {
          this.$confirm({
            title: '遇到问题?',
            content: h => <div>可能是以下原因导致您支付失败，您可以对照进行问题排查：<br/>(1)支付宝或是网银交易会有支付上限，建议您登录网上银行提高最高上限额度，即能轻松支付。<br/>(2)部分浏览器发生兼容性冲突导致支付失败，建议您使用IE浏览器进行支付操作。<br/>(3)支付宝或是网银页面等提示"页面过期、超时、错误"等问题时，您可以关闭浏览器后重新打开再进行支付。<br/>联系客服/商务： <br/>QQ群1104611646 电话0755-83537936</div>,
            okText: '我知道了',
            // onCancel: null
            cancelText: null
          })
        }

      })
    },
    async recharge() {
      if (!this.agree) {
        this.$message.warning('请阅读并同意《快递鸟企业寄件服务协议》')
        return
      }
      this.getOrder()
    }
  }
}
</script>
<style lang="scss">
.recharge{
    .post-form{
        position: absolute;
        z-index: -11;
        opacity: 0;
        cursor: pointer;
        input{
            width: 300px;
        height: 32px;
        cursor: pointer;
        }
    }
    .post-btn{
        position: relative;
    }
    .money-item{
        cursor: pointer;
        border-radius:2px;
        border:1px solid rgba(0,0,0,0.15);
        width:160px;
        height:60px;
        text-align: center;
        line-height: 60px;
    }
}
</style>
